import type { PurchaseOrderDetail } from '../../../services/purchaseOrders';
import { AddressPill } from '../../shared/AddressPill';
import { KVRow } from '../Drawer';
import { fmtPoDate } from './poFormat';
import { PurchaseOrderFileLink } from './PurchaseOrderFileLink';
import { PurchaseOrderZone } from './PurchaseOrderZone';

interface DispatchZoneProps {
    purchaseOrder: PurchaseOrderDetail;
}

export function PurchaseOrderDispatchZone({ purchaseOrder }: DispatchZoneProps) {
    const isExternal = purchaseOrder.ordersVia === 'external';
    const id = purchaseOrder.id;

    return (
        <PurchaseOrderZone title="Dispatch">
            <div className="flex flex-col">
                <KVRow k="Channel">{isExternal ? 'Vendor website' : 'Email'}</KVRow>
                <KVRow k={isExternal ? 'Placed' : 'Sent'}>{fmtPoDate(purchaseOrder.sentAt)}</KVRow>
                {purchaseOrder.sentTo.length > 0 && (
                    <KVRow k="Sent to">
                        {/* The addresses used at send time, kept so a retry
                            cannot silently reach someone different. */}
                        <span className="flex flex-wrap justify-end gap-1.5">
                            {purchaseOrder.sentTo.map((recipient) => (
                                <AddressPill key={recipient} address={recipient} />
                            ))}
                        </span>
                    </KVRow>
                )}
                <KVRow k="Document">
                    {purchaseOrder.documentFile ? (
                        <PurchaseOrderFileLink
                            purchaseOrderId={id}
                            fileId={purchaseOrder.documentFile.id}
                            label={purchaseOrder.documentFile.originalFilename}
                        />
                    ) : (
                        <span className="text-gray-400">not generated</span>
                    )}
                </KVRow>
            </div>
        </PurchaseOrderZone>
    );
}
